import { CompactIcon } from "@/domains/icons"

import { SwitchWithLabel } from "./switch-with-label"

export const SwitchDetailedMode = ({
  checked,
  onCheckedChange,
}: {
  checked: boolean
  onCheckedChange: (value: boolean) => void
}) => {
  return (
    <SwitchWithLabel
      label="Detailed Mode"
      iconLeft={<CompactIcon size={16} />}
      checked={checked}
      onCheckedChange={onCheckedChange}
    />
  )
}
